<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='15'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <!--右侧开始-->
          <div class="cght_htmainrighttop" style="padding-top: 5px;" v-show="false">
            <div class="cght_htmainrighttopl" style="margin-left: 20px;">
              <img src="../../assets/images/Z37_01.png" style="width: 55px;box-shadow: 0 0 5px #cbdaf5;border-radius: 10px;">
              <span style="font-size: 12px;color: #757575;">数据统计</span>
            </div>
            <div class="cght_htmainrighttopl" style="margin-left: 20px;">
              <img src="../../assets/images/Z37_01.png" style="width: 55px;box-shadow: 0 0 5px #cbdaf5;border-radius: 10px;">
              <span style="font-size: 12px;color: #757575;">数据统计</span>
            </div>
            <div class="cght_htmainrighttopl" style="margin-left: 20px;">
              <img src="../../assets/images/Z37_01.png" style="width: 55px;box-shadow: 0 0 5px #cbdaf5;border-radius: 10px;">
              <span style="font-size: 12px;color: #757575;">数据统计</span>
            </div>
            <div class="cght_htmainrighttopl" style="margin-left: 20px;">
              <img src="../../assets/images/Z37_01.png" style="width: 55px;box-shadow: 0 0 5px #cbdaf5;border-radius: 10px;">
              <span style="font-size: 12px;color: #757575;">数据统计</span>
            </div>
            <div class="cght_htmainrighttopl" style="margin-left: 20px;">
              <img src="../../assets/images/Z37_01.png" style="width: 55px;box-shadow: 0 0 5px #cbdaf5;border-radius: 10px;">
              <span style="font-size: 12px;color: #757575;">数据统计</span>
            </div>
          </div>
          <div class="cght_htmainrighttop">
            <div class="cght_htmainrighttopl">统计</div>
            <div class="cght_htmainrighttopr">
              <div class="cght_htmainrighttoprl">
                <!-- <router-link :to="{path:'/Address'}">我的收货地址</router-link> -->
              </div>
            </div>
          </div>
          <div class="cght_subpagemaina" v-loading="qyloading">
            <el-menu default-active="3" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item index="3">统计预览</el-menu-item>
              <el-menu-item index="1">采购明细统计</el-menu-item>
              <el-menu-item index="2">现金开支统计</el-menu-item>
            </el-menu>
            <div v-show="showindex == '1'" class="DauUse">
              <el-row>
                <el-col :span="12">
                  <el-cascader v-model="company" :options="companyList" clearable filterable :props="{ value: 'id',label: 'name', checkStrictly: true }"  style="width: 100%;" placeholder="请选择厂区" @change="afreshData()" size="small"></el-cascader>
                </el-col>
                <el-col :span="4">
                  <el-select v-model="listQuery.pay_state" placeholder="请选择支付方式" clearable @change="HandleCom" size="small">
                    <el-option
                      v-for="item in pay_stateList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4">
                  <el-select v-model="listQuery.pay_source" placeholder="请选择购买来源" clearable @change="HandleCom" size="small">
                    <el-option
                      v-for="item in pay_sourceList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4">
                  <el-select v-model="listQuery.invoice" placeholder="请选择发票" clearable @change="HandleCom" size="small">
                    <el-option
                      v-for="item in invoiceList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-date-picker
                    v-model="addtimeBTTime"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    @change="selectOperationTime"
                    size="small"
                  >
                  </el-date-picker>
                </el-col>
                <el-col v-if="current_user.id == 2 || current_user.id == 100" :span="4" style="padding-left:30px">
                  <el-select v-model="user_id" placeholder="用户" clearable @change="HandleComUser" size="small">
                    <el-option
                      v-for="item in user_idList"
                      :key="item.user_id"
                      :label="item.name"
                      :value="item.user_id">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4">
                  <el-select v-model="listQuery.return_invoice" placeholder="是否回票" clearable @change="HandleCom" size="small">
                    <el-option
                      v-for="item in return_invoiceList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="7">
                  <div style="padding-top:3px;">
                    <em style="font-size:14px;font-weight:bold;font-style:normal;margin-left:40px;color: #409eff;">总共：</em>
                    <count-to :start-val="0" :end-val="total_price" :duration="2600" class="card-panel-num" style="color:#13ce66;font-weight:bold;font-size:14px;" :decimals="2" />
                  </div>
                </el-col>
                <el-col :span="1">
                  <div style="padding-top:5px;padding-left:20px;">
                    <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="dialogVisible2 = true"></i>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="comP2" ref="seller_1"></div>
                </el-col>
              </el-row>
            </div>
            <div v-show="showindex == '2'" class="DauUse">
              <el-row>
                <el-col v-if="current_user.id == 2 || current_user.id == 100" :span="3">
                  <el-select v-model="user_id2" placeholder="用户" clearable @change="HandleComUser2" size="small">
                    <el-option
                      v-for="item in user_idList"
                      :key="item.user_id"
                      :label="item.name"
                      :value="item.user_id">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4">
                  <el-select v-model="listQuery2.exp_type" placeholder="请选择支出类型" clearable @change="HandleCom2" size="small">
                    <el-option
                      v-for="item in exp_typeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-date-picker
                    v-model="addtimeBTTime2"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    @change="selectOperationTime2"
                    size="small"
                  >
                  </el-date-picker>
                </el-col>
                <el-col :span="1">
                  <div style="padding-top:5px;padding-left:350px;">
                    <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="dialogVisible3 = true"></i>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div style="padding-top:3px;">
                    <em style="font-size:14px;font-weight:bold;font-style:normal;color: #409eff;">总预支：</em>
                    <count-to :start-val="0" :end-val="income" :duration="2600" class="card-panel-num" style="color:#13ce66;font-weight:bold;font-size:14px;" :decimals="2" />
                    <em style="font-size:14px;font-weight:bold;font-style:normal;margin-left:20px;color: #409eff;">总支出：</em>
                    <count-to :start-val="0" :end-val="expenditure" :duration="2600" class="card-panel-num" style="color:#ff4949;font-weight:bold;font-size:14px;" :decimals="2" />
                    <em style="font-size:14px;font-weight:bold;font-style:normal;margin-left:20px;color: #409eff;">总余额：</em>
                    <count-to :start-val="0" :end-val="balance" :duration="2600" class="card-panel-num" style="color:#f48504;font-weight:bold;font-size:14px;" :decimals="2" />
                    <em style="font-size:14px;font-weight:bold;font-style:normal;margin-left:20px;color: #409eff;">总采购支出：</em>
                    <count-to :start-val="0" :end-val="expenses" :duration="2600" class="card-panel-num" style="color:#ff4949;font-weight:bold;font-size:14px;" :decimals="2" />
                    <em style="font-size:14px;font-weight:bold;font-style:normal;margin-left:20px;color: #409eff;">总费用支出：</em>
                    <count-to :start-val="0" :end-val="expenditure - expenses" :duration="2600" class="card-panel-num" style="color:#ff4949;font-weight:bold;font-size:14px;" :decimals="2" />
                    <em v-show="listQuery2.exp_type" style="font-size:14px;font-weight:bold;font-style:normal;margin-left:20px;color: #409eff;">{{ expName }}支出：</em>
                    <count-to v-show="listQuery2.exp_type" :start-val="0" :end-val="expTypeval" :duration="2600" class="card-panel-num" style="color:#ff4949;font-weight:bold;font-size:14px;" :decimals="2" />
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="comP2" ref="seller_2"></div>
                </el-col>
              </el-row>
            </div>
            <div v-show="showindex == '3'" class="DauUse">
              <el-row>
                <el-col v-if="current_user.id == 2 || current_user.id == 100" :span="3">
                  <el-select v-model="user_id3" placeholder="用户" clearable @change="HandleComUser3" size="small">
                    <el-option
                      v-for="item in user_idList"
                      :key="item.user_id"
                      :label="item.name"
                      :value="item.user_id">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-date-picker
                    v-model="addtimeBTTime3"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    @change="selectOperationTime3"
                    size="small"
                  >
                  </el-date-picker>
                </el-col>
                <el-col :span="6">
                  <div style="padding-top:3px;">
                    <em style="font-size:14px;font-weight:bold;font-style:normal;margin-left:40px;color: #409eff;">总计：</em>
                    <count-to :start-val="0" :end-val="pieval4" :duration="2600" class="card-panel-num" style="color:#ff4949;font-weight:bold;font-size:14px;" :decimals="2" />
                  </div>
                </el-col>
                <el-col :span="1">
                  <div style="padding-top:5px;padding-left:260px;">
                    <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="dialogVisible1 = true"></i>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="comP2" ref="seller_3"></div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="统计预览说明"
      :visible.sync="dialogVisible1"
      width="50%">
      <el-image
        style="width: 100%;"
        src="https://serv.nmzp.com/uploads/1/image/20240408/c1dd6f51dd14d1c6c56ab390ea185349.png"
        :preview-src-list=srcList1>
      </el-image>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible1 = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="采购明细统计说明"
      :visible.sync="dialogVisible2"
      width="50%">
      <el-image
        style="width: 100%;"
        src="https://serv.nmzp.com/uploads/1/image/20240408/78d5bce68da302376f80ad1dd4e6d22a.png"
        :preview-src-list=srcList2>
      </el-image>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="账单列表统计说明"
      :visible.sync="dialogVisible3"
      width="50%">
      <el-image
        style="width: 100%;"
        src="https://serv.nmzp.com/uploads/1/image/20240408/a341f75394c5943d130387c2428723fc.png"
        :preview-src-list=srcList2>
      </el-image>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible3 = false">确 定</el-button>
      </span>
    </el-dialog>
    <Bottom/>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import { mapGetters } from 'vuex'
import api from '@/api/order'
import expense from '@/api/expense'
import CountTo from 'vue-count-to'

export default {
  name: 'MyOrder',
  components: { Top, LeftNav, Bottom, CountTo },
  data () {
    return {
      api,
      showindex: '3',
      // 过滤条件
      listQuery: {
        pay_state: '',
        pay_source: '',
        invoice: '',
        return_invoice: '',
        group_list_id: '',
        company_id: '',
        plant_id: '',
        user_id: ''
      },
      company: [],
      user_id: '',
      addtimeBTTime: [],
      companyList: [],
      user_idList: [],
      pay_stateList: [
        {
          value: '1',
          label: '对公打款'
        },
        {
          value: '2',
          label: '现金'
        }
      ],
      pay_sourceList: [
        {
          value: '1',
          label: '淘宝'
        },
        {
          value: '2',
          label: '本地'
        },
        {
          value: '3',
          label: '京东'
        },
        {
          value: '4',
          label: '西域'
        },
        {
          value: '5',
          label: '震坤行'
        },
        {
          value: '6',
          label: '微信'
        },
        {
          value: '7',
          label: '旺旺'
        },
        {
          value: '8',
          label: '其他'
        }
      ],
      invoiceList: [
        {
          value: '1',
          label: '专票'
        },
        {
          value: '2',
          label: '普票'
        },
        {
          value: '3',
          label: '无'
        }
      ],
      return_invoiceList: [
        {
          value: '已回票',
          label: '已回票'
        },
        {
          value: '未回票',
          label: '未回票'
        }
      ],
      qyloading: false,
      alldata: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      total_price: 0,
      setOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value'
        },
        yAxis: {
          type: 'category',
          data: []
        },
        series: [
          {
            name: '1月',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: [],
            markPoint: {
              data: [],
              label: {
                // 显示标记点的文字
                show: true,
                position: 'top'
              },
              // 设置标记点不显示图标
              symbol: 'image://https://www.example.com/image.jpg'
            }
          },
          {
            name: '2月',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '3月',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '4月',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '5月',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '6月',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '7月',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '8月',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '9月',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '10月',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '11月',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '12月',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: []
          }
        ]
      },
      alldata2: [],
      user_id2: '',
      exp_typeList: [
        {
          value: '1',
          label: '物流费'
        },
        {
          value: '2',
          label: '差旅费'
        },
        {
          value: '3',
          label: '交通费'
        },
        {
          value: '4',
          label: '销售费'
        },
        {
          value: '5',
          label: '房屋租赁'
        },
        {
          value: '6',
          label: '办公用品'
        },
        {
          value: '7',
          label: '其他'
        }
      ],
      listQuery2: {
        type: ''
      },
      typeList: [
        {
          value: '1',
          label: '支出'
        },
        {
          value: '2',
          label: '收入'
        }
      ],
      addtimeBTTime2: [],
      setOption2: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['预支', '支出', '余额']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'value'
          }
        ],
        yAxis: [
          {
            type: 'category',
            axisTick: {
              show: false
            },
            data: []
          }
        ],
        series: [
          {
            name: '预支',
            type: 'bar',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: [],
            itemStyle: {
              // 为这个系列单独设置颜色
              color: 'rgb(19, 206, 102)'
            }
          },
          {
            name: '支出',
            type: 'bar',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: [],
            itemStyle: {
              // 为这个系列单独设置颜色
              color: 'rgb(255, 73, 73)'
            }
          },
          {
            name: '余额',
            type: 'bar',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: [],
            itemStyle: {
              // 为这个系列单独设置颜色
              color: 'rgb(244, 133, 4)'
            }
          }
        ]
      },
      expenditure: 0,
      income: 0,
      balance: 0,
      expenses: 0,
      expTypeval: 0,
      expName: '',
      alldata3: [],
      user_id3: '',
      addtimeBTTime3: [],
      setOption3: {
        title: {
          text: '统计预览',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '统计',
            type: 'pie',
            radius: '50%',
            data: [
              { value: 0, name: '' },
              { value: 0, name: '' },
              { value: 0, name: '' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              normal: {
                show: true,
                formatter: '{b}（{d}%）'
              }
            }
          }
        ]
      },
      listQuery3: {
        user_id: '',
        pay_state: ''
      },
      listQuery4: {
        user_id: '',
        type: 1,
        buy_type: 0
      },
      pieval1: '',
      pieval2: '',
      pieval3: '',
      pieval4: 0,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      srcList1: ['https://serv.nmzp.com/uploads/1/image/20240408/c1dd6f51dd14d1c6c56ab390ea185349.png'],
      srcList2: ['https://serv.nmzp.com/uploads/1/image/20240408/78d5bce68da302376f80ad1dd4e6d22a.png'],
      srcList3: ['https://serv.nmzp.com/uploads/1/image/20240408/a341f75394c5943d130387c2428723fc.png']
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  watch: {
    alldata: {
      handler (newValue, oldValue) {
        if (newValue) {
          this.alldata = newValue
        } else {
          this.alldata = oldValue
        }
        this.drawLine()
      }
    },
    alldata2: {
      handler (newValue, oldValue) {
        if (newValue) {
          this.alldata2 = newValue
        } else {
          this.alldata2 = oldValue
        }
        this.drawLine2()
      }
    },
    alldata3: {
      handler (newValue, oldValue) {
        if (newValue) {
          this.alldata3 = newValue
        } else {
          this.alldata3 = oldValue
        }
        this.drawLine3()
      }
    }
  },
  mounted () {
    this.getData3()
    this.getCompanyList()
    this.drawLine3()
  },
  methods: {
    handleSelect (key) {
      this.$nextTick(() => {
        this.showindex = key
        if (key === '1') {
          this.drawLine()
          this.getData()
        } else if (key === '2') {
          this.drawLine2()
          this.getData2()
        } else {
          this.drawLine3()
          this.getData3()
        }
      })
    },
    getCompanyList () {
      expense.getCompanyList().then(response => {
        this.companyList = response.message
      })
    },
    drawLine () {
      // 采购明细统计查看
      this.$nextTick(() => {
        this.myChartline = this.$echarts.init(this.$refs.seller_1)
        this.myChartline.setOption(this.setOption)
      })
    },
    afreshData () {
      this.listQuery.group_list_id = this.company[0]
      this.listQuery.company_id = this.company[1]
      this.listQuery.plant_id = this.company[2]
      this.getData()
    },
    selectOperationTime () {
      if (this.addtimeBTTime) {
        this.listQuery.addtimeBTTime = this.addtimeBTTime
      } else {
        this.listQuery.addtimeBTTime = []
      }
      this.getData(this.listQuery)
    },
    HandleCom () {
      this.getData(this.listQuery)
    },
    HandleComUser () {
      this.listQuery.user_id = this.user_id
      this.getData(this.listQuery)
    },
    getData () {
      if (this.current_user.id === 2 || this.current_user.id === 100) {
        // this.$delete(this.listQuery, 'user_id')
      } else {
        this.listQuery.user_id = this.current_user.id
      }
      expense.getData(this.listQuery).then(response => {
        this.alldata = response.message
        this.total_price = response.total_price
        this.setOption.yAxis.data = response.user_name
        this.setOption.series[0].data = response.month1
        this.setOption.series[1].data = response.month2
        this.setOption.series[2].data = response.month3
        this.setOption.series[3].data = response.month4
        this.setOption.series[4].data = response.month5
        this.setOption.series[5].data = response.month6
        this.setOption.series[6].data = response.month7
        this.setOption.series[7].data = response.month8
        this.setOption.series[8].data = response.month9
        this.setOption.series[9].data = response.month10
        this.setOption.series[10].data = response.month11
        this.setOption.series[11].data = response.month12
        if (response.month) {
          this.setOption.series[0].data = response.month
          this.setOption.series[0].name = this.addtimeBTTime[0] + '至' + this.addtimeBTTime[1]
          this.setOption.series[1].name = ''
          this.setOption.series[2].name = ''
          this.setOption.series[3].name = ''
          this.setOption.series[4].name = ''
          this.setOption.series[5].name = ''
          this.setOption.series[6].name = ''
          this.setOption.series[7].name = ''
          this.setOption.series[8].name = ''
          this.setOption.series[9].name = ''
          this.setOption.series[10].name = ''
          this.setOption.series[11].name = ''
          this.setOption.series[0].markPoint.data = []
        } else {
          this.setOption.series[0].name = '1月'
          this.setOption.series[1].name = '2月'
          this.setOption.series[2].name = '3月'
          this.setOption.series[3].name = '4月'
          this.setOption.series[4].name = '5月'
          this.setOption.series[5].name = '6月'
          this.setOption.series[6].name = '7月'
          this.setOption.series[7].name = '8月'
          this.setOption.series[8].name = '9月'
          this.setOption.series[9].name = '10月'
          this.setOption.series[10].name = '11月'
          this.setOption.series[11].name = '12月'
          this.setOption.series[0].markPoint.data = []
          for (var i = 0; i < response.total.length; i++) {
            var markPointData = { value: '总计：' + response.total[i], yAxis: i, x: '95%' }
            this.setOption.series[0].markPoint.data.push(markPointData)
          }
        }
      })
    },
    HandleCom2 (val) {
      this.getData2(this.listQuery2)
      if (val) {
        let obj = {}
        obj = this.exp_typeList.find((item) => {
          return item.value === val
        })
        this.expName = obj.label
      }
    },
    HandleComUser2 () {
      this.listQuery2.user_id = this.user_id2
      this.getData2(this.listQuery2)
    },
    getData2 () {
      if (this.current_user.id === 2 || this.current_user.id === 100) {
        // this.$delete(this.listQuery, 'user_id')
      } else {
        this.listQuery2.user_id = this.current_user.id
      }
      this.setOption2.yAxis[0].data = []
      this.setOption2.series[0].data = []
      this.setOption2.series[1].data = []
      this.setOption2.series[2].data = []
      expense.getData2(this.listQuery2).then(response => {
        if (this.listQuery2.exp_type) {
          this.alldata2 = response.message
          this.setOption2.yAxis[0].data = response.user_name
          this.setOption2.series[1].data = response.zc
          this.expTypeval = response.expenditure
        } else {
          this.alldata2 = response.message
          this.setOption2.yAxis[0].data = response.user_name
          this.setOption2.series[0].data = response.yz
          this.setOption2.series[1].data = response.zc
          this.setOption2.series[2].data = response.ye
          this.expenditure = response.expenditure
          this.income = response.income
          this.balance = response.balance
          this.expenses = response.expenses
        }
      })
    },
    selectOperationTime2 () {
      if (this.addtimeBTTime2) {
        this.listQuery2.addtimeBTTime2 = this.addtimeBTTime2
      } else {
        this.listQuery2.addtimeBTTime2 = []
      }
      this.getData2(this.listQuery2)
    },
    drawLine2 () {
      // 账单列表统计查看
      this.$nextTick(() => {
        this.myChartline2 = this.$echarts.init(this.$refs.seller_2)
        this.myChartline2.setOption(this.setOption2)
      })
    },
    selectOperationTime3 () {
      if (this.addtimeBTTime3) {
        this.listQuery.addtimeBTTime = this.addtimeBTTime3
        this.listQuery2.addtimeBTTime2 = this.addtimeBTTime3
      } else {
        this.listQuery.addtimeBTTime = []
        this.listQuery2.addtimeBTTime2 = []
      }
      this.getData3()
    },
    drawLine3 () {
      // 统计预览
      this.myChartline3 = this.$echarts.init(this.$refs.seller_3)
      this.myChartline3.setOption(this.setOption3)
    },
    HandleComUser3 () {
      this.listQuery3.user_id = this.user_id3
      this.listQuery4.user_id = this.user_id3
      this.getData3()
    },
    getData3 () {
      if (this.current_user.id === 2 || this.current_user.id === 100) {
        // this.$delete(this.listQuery, 'user_id')
      } else {
        this.listQuery3.user_id = this.current_user.id
        this.listQuery4.user_id = this.current_user.id
      }
      this.setOption3.series[0].data = [{ value: 0, name: '' }, { value: 0, name: '' }, { value: 0, name: '' }]
      this.pieval4 = 0
      // 对公打款
      this.listQuery3.pay_state = '1'
      expense.getData(this.listQuery3).then(response => {
        this.alldata3 = response.message
        this.user_idList = response.user
        this.pieval1 = response.total_price
        this.pieval4 += Number(this.pieval1)
        this.setOption3.series[0].data[0].name = '采购明细对公打款——' + this.pieval1
        this.setOption3.series[0].data[0].value = this.pieval1
      })
      // 现金
      this.listQuery3.pay_state = '2'
      expense.getData(this.listQuery3).then(response => {
        this.alldata3 = response.message
        this.pieval2 = response.total_price
        this.pieval4 += Number(this.pieval2)
        this.setOption3.series[0].data[1].name = '采购明细现金——' + this.pieval2
        this.setOption3.series[0].data[1].value = this.pieval2
      })
      // 账单列表支出
      expense.getData3(this.listQuery4).then(response => {
        this.alldata3 = response.message
        this.pieval3 = response.pieval3
        this.pieval4 += Number(this.pieval3)
        this.setOption3.series[0].data[2].name = '账单列表支出总计——' + this.pieval3
        this.setOption3.series[0].data[2].value = this.pieval3
      })
    }
  }
}
</script>
<style scoped>
.DauUse {
  padding-top: 10px;
}
.el-row {
  padding-bottom: 10px;
}
.el-col {
  padding-right: 10px;
}
.comP2 {
  width: 100%;
  height: 500px;
}
.el-image >>> .el-image-viewer__close{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/member/index.vue